<div class="lists">
  <div *ngFor="let list of packLists" class="list-box">
    <app-list-summary [list]="list"></app-list-summary>
  </div>
</div>
